import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertaService {
  private mostrarAlerta$ = new BehaviorSubject<boolean>(true);

  abrir() {
    this.mostrarAlerta$.next(true);
  }

  fechar() {
    this.mostrarAlerta$.next(false);
  }

  toggle() {
    this.mostrarAlerta$.next(!this.mostrarAlerta$.value);
  }

  isVisivel() {
    return this.mostrarAlerta$.asObservable(); // componentes podem se inscrever
  }

  get valorAtual(): boolean {
    return this.mostrarAlerta$.value;
  }
}